module.exports = __webpack_public_path__ + "static/media/img1.d1ac149f.jpg";